/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_SuccessInputs */

const en_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap To shot changes finished successfully`)
};

const fr_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alignement sur les changements de plan terminé avec succès`)
};

const de_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap-to-Aufnahmewechsel erfolgreich abgeschlossen`)
};

const it_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche di Snap To shot completate con successo`)
};

const ru_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения в снимок Snap To успешно завершены.`)
};

const es_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los cambios en la toma Ajustar a se finalizaron correctamente`)
};

const zh_cn2_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照更改已成功完成`)
};

const ja_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スナップ ショットの変更が正常に完了しました`)
};

const hi_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्नैप टू शॉट में किए गए बदलाव सफलतापूर्वक पूरे हो गए।`)
};

const pt_pt2_snap_to_shot_changes_success = /** @type {(inputs: Snap_To_Shot_Changes_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As alterações de disparo do Snap To foram concluídas com sucesso.`)
};

/**
* | output |
* | --- |
* | "Snap To shot changes finished successfully" |
*
* @param {Snap_To_Shot_Changes_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_success = /** @type {((inputs?: Snap_To_Shot_Changes_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_shot_changes_success(inputs)
	if (locale === "de") return de_snap_to_shot_changes_success(inputs)
	if (locale === "it") return it_snap_to_shot_changes_success(inputs)
	if (locale === "ru") return ru_snap_to_shot_changes_success(inputs)
	if (locale === "es") return es_snap_to_shot_changes_success(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_shot_changes_success(inputs)
	if (locale === "ja") return ja_snap_to_shot_changes_success(inputs)
	if (locale === "hi") return hi_snap_to_shot_changes_success(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_shot_changes_success(inputs)
	return en_snap_to_shot_changes_success(inputs)
});